import { render, staticRenderFns } from "./brandedNavbar.vue?vue&type=template&id=49b8f6a4&scoped=true&"
var script = {}
import style0 from "./brandedNavbar.vue?vue&type=style&index=0&id=49b8f6a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b8f6a4",
  null
  
)

export default component.exports